import { createSlice } from '@reduxjs/toolkit';
import {
    tesla,
} from '../actions/tesla';


export const TeslaReducer = createSlice({
    name: 'tesla',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(tesla.pending, (state) => { state.loading = true })
            .addCase(tesla.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(tesla.rejected, (state) => { state.loading = false })
    }
})

export default TeslaReducer.reducer;